import { FunctionComponent } from 'react';
import { HeaderProps } from './types';
import { Container } from './layout/Container';

export const Header: FunctionComponent<HeaderProps> = ({ title, headline, lightWeight }) => (
  <Container customContainerClassName='termsapp-component-header'>
    <div className={lightWeight ? 'termsapp-component-dual-headline' : ''}>
      <h1>{title}</h1>
      <p>{headline}</p>
    </div>
  </Container>
);
